<template>
  <Layout>
    <div>
      <span class="bold-title">Dashboard Page</span>
      <div>
        <span class="underlined">Filters:</span> On dashboard page, there is two filters that you can use to see
        your numbers in details. Dashboard reports shows total number if no
        filter has been selected.
      </div>
      <div>
        <span class="underlined">Company Selection:</span> if you have multiple companies in your account, Click
        to arrow on right side of Select Company box. Choose the company or
        companies you would like to filter.
      </div>
      <div>
        <span class="underlined">Location Selection:</span> If you have multiple location your account, Click to
        arrow on right side of Select Location box. Choose the location or
        locations you would like to filter. To activate Select Location box, you
        should first choose the company associated with location.
      </div>
      <div>
        <span class="underlined">Fleet Composition:</span> graph shows the total Fleet Composition for all
        locations by vehicle class. Subject graph demonstrate the percentage of
        vehicles classes on all locations/companies.
      </div>
      <div>
        <span class="underlined">Percentage of Class by Vehicle Group:</span> graph shows the percentage of
        vehicle classes in defined vehicle groups.
      </div>
      <div>
        <span class="underlined">Fleet Composition by Location:</span> graph shows the fleet composition by
        vehicle class per location.
      </div>
      <div>
        <span class="underlined">Ownership Type Percentage:</span> 1 graph shows the type of vehicle ownership
        as percentage of all locations.
      </div>
      <div>
        <span class="underlined">Avg of Monthly Payment by Vehicle Class:</span> 1 graph shows the average $
        payment ( lease/finance/etc) to financial companies grouped by vehicle
        class.
      </div>
      <div>
        <span class="underlined">Total of Monthly Payment by Vehicle Class:</span> 1 graph shows the total $
        payment ( lease/finance/etc) to financial companies grouped by vehicle
        class.
      </div>
      <div>
        <span class="underlined">Classes have positive Equity:</span> 1 graph shows vehicles classes that have
        positive equity based on estimated pay-off ( to financial companies for
        lease/finance/etc ) amount calculation.
      </div>
      <div>
        This graph shows results that only if vehicle’s financial information
        has been provided.
      </div>
      <span class="bold-title">
        Fleet View - Total Value Page
      </span>
      <div>
        Results on this page grouped by Companies. To able to see details of
        every location, please click to arrow sign near to company name. This
        graph’s calculations are based on vehicles that financial information
        has been provided to FMS. If vehicle’s financial information hasn’t been
        provided, those vehicles aren’t included the calculation of the fleet
        size, auction value, estimated payoff and estimated rev/loss columns.
      </div>
      <div>
        <span class="underlined">Fleet Size:</span> Total Vehicle count. Only vehicles that have financial
        information are included on this count.
      </div>
      <div>
        <span class="underlined">Auction Value:</span> This is the vehicle’s total estimated Auction Value. This
        information is from database either from JdPower or Manheim based on
        user’s selection
      </div>
      <div>
        <span class="underlined">Estimated Payoff:</span> This is the vehicle’s total estimated Payoff amount
        calculation. This information is from calculation based on entered
        financial information to the FMS.
      </div>
      <div>
        <span>Estimated Revenue/Loss:</span> This the difference of estimated Auction Value
        and Estimated Payoff that vehicles have financial information at FMS.
      </div>
      <span class="bold-title">
        Fleet View - Value by Vehicle Page
      </span>
      <div>
        This is a table page shows the current market valuation of user’s fleet.
        Every line shows detail information of vehicles that’s entered to FMS.
        This table is interactive so user can filter, modify the table as how
        user would like to get the information from this table.
      </div>
      <div>
        <span class="underlined">Filter By Company & Location:</span> Same as Dashboard page, User can choose “
        Company “ and “ Location “ from “ Select Company “ and “ Select Location
        “ boxes.
      </div>
      <div>
        <span class="underlined">Vehicle Condition Assumption:</span> With using this drop down menu, user can
        see Market Values based on Vehicle’s current condition that’s entered by
        user or by choosing from option “Above, Average, Below“ from drop down
        menu, user can override all of the vehicles at list to chosen Vehicle
        condition option.
      </div>
      <div>
        <span class="underlined">Advanced Filters:</span> By clicking Advanced filters button, a filter menu
        will pop-up. User can choose any filter option and by clicking apply,
        chosen filters will be applied to the list. User can choose more than
        one option by clicking to top of it, if user would like use multiple
        filter options. And if user would like to delete the filter, user should
        click to advanced filter button again, and click to “ X “ icon near to
        options, and click apply to cancel applied filters. Or by simply
        clicking reset button, user can delete all of the applied filter at
        once.
      </div>
      <div>
        <span class="underlined">Identified/Not Identified Switch:</span> If the switch is on “ Identified “ the
        list shows the vehicles that have Financial information at FMS, if it’s
        on “ Not Identified “ , than the list only show the vehicles that don’t
        have any Financial information at FMS. If “ Not Identified “ chosen,
        since vehicles don’t have any financial information, this list can only
        provide the market value of vehicles, this list cannot be able to
        provide the “ Estimated Pay-off “ and “ Estimated Rev/Loss “
        information.
      </div>
      <div>
        <span class="underlined">Visible Columns:</span> By clicking grey downward arrow, user can manage the
        columns to make visible, or hide. To able to that, first click to arrow,
        than click to column name either to make it visible or hidden. If the
        color of column name is black, than it means that that column is hidden,
        if the color is navy, than it means that the column is visible.
      </div>
      <div>
        <span class="underlined">Change Column Order:</span> User can manage the order of the column. Simple
        hold the left button of mouse when the cursor at top of the column
        title. While holding the cursor, user can move the column to left or
        right.
      </div>
      <div>
        <span class="underlined">Exporting to Excel:</span> User can export the list of vehicles to an excel
        spreadsheet. Either all of the vehicles on list or only the chosen ones
        can be exported. To able to pick only some of the vehicles, click to
        boxes on near to line number of vehicle. After selection, click to
        export button on left side menu, and choose either internal or external
        and click “ Export “, than the excel spreadsheet will be downloaded.
        Internal report will export the excel which has the all information
        shown at the list including market values and financial calculated
        information. External report will export the excel which only has
        information about vehicle, it won’t export any financial information.
      </div>
      <span class="bold-title">Future Projection - Value by Vehicle Page</span>
      <div>
        This page design to show user the Future Projected Market Value’s by
        using JDPower datasource. To see one future market values of specific
        vehicle, first please choose which month user would like to see data
        for. For example, if user would like to see the 3rd month in future,
        user should input number “ 3 “ to the “ Months “ field. Than choose the
        location from “ Select Location “ or to see all locations vehicles,
        choose “ All Locations “ . Remember if “ All Locations “ chosen, than
        assumptions would be used for all locations as same. Than please enter
        the user’s Monthly Depreciation Assumption and Monthly Mileage
        Assumptions to the related boxes. After entering all necessary
        information, need to click “ Calculate “ button to run the report.
      </div>
      <div>
        Run a report for multiple locations by entering different assumptions
        please follow steps below;
        <ul>
          <li>Select the Location</li>
          <li>Enter Monthly Depreciation and Mileage Assumption</li>
          <li>Click “ + “ to add to the report list</li>
          <li>For second Location, choose the location</li>
          <li>Enter Monthly Depreciation and Mileage Assumption</li>
          <li>
            Click “ + “ to add to the report list and continue doing same steps
            until all wanted locations entered.
          </li>
          <li>Than click to blue Calculate button to run the report</li>
        </ul>
      </div>
      <div>
        Search via VIN: After running the report, to able to find a vehicle by
        searching via VIN, please enter the VIN to the field on the top and
        click enter.
      </div>
      <span class="bold-title">Projected Rev/Loss Page</span>
      <div>
        This page designed to demonstrate the projected rev/loss of total fleet
        valuation. Needs to be remembered that in this reports calculation, only
        vehicles that have financial information are included.
      </div>
      <div>
        The logic of calculation is below;
      </div>
      <div>
        Based On Projected Auction Value: This is calculated by the difference
        of total Projected Vehicle JDPower-Auction Value and total Estimated
        Pay-off amount to financial companies.
      </div>
      <div>
        Based on Owner Depr. Assumption: This is calculated by the difference of
        total Vehicle’s Value based on Owner Depr. Assumption ( which is entered
        to Location setting ) and total Estimated Pay-off amount to financial
        companies.
      </div>
      <span class="bold-title">
        Manheim Valuation Page
      </span>
      <div>
        This page designed to run a report of Manheim Market Value by VIN. To
        able to get Manheim Market Value date please follow steps below;
      </div>
      <div>
        <ul>
          <li>Enter the Vehicle’s VIN to “ VIN “ section box</li>
          <li>Enter Vehicle’s Mileage to “ Mileage “ section box</li>
          <li>
            Choose the region for Manheim Market Valuation. Every region may
            have different vehicle valuation because of the market difference.
            If average valuation needed , than choose “ National “
          </li>
          <li>Click “ Add “ , then click “ Search “</li>
        </ul>
      </div>
      <span class="underlined">For Multiple VIN report:</span>
      <div>
        <ul>
          <li>
            Enter first Vehicles, VIN , Mileage and Region information
          </li>
          <li>
            Click to “ Add “
          </li>
          <li>
            Enter the other Vehicles VIN, Mileage and Region information
          </li>
          <li>
            Click to “ Add “ and repeat steps above for every needed VIN’s.
          </li>
          <li>After the last VIN adding, click “ Search “</li>
        </ul>
      </div>
      <div>
        <span class="underlined">Change Vehicle Condition:</span> Manheim Valuation provides different values by
        vehicle’s condition. There is 3 option to choose as Vehicle condition; “Above, Average, Below“.
        Like in Fleet View - Value by Vehicle page, by clicking top of the Vehicle condition, a drop down menu opens,
        choose and click to condition and valuation refresh automatically.
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../components/Layout.vue";
export default {
  components: {
    Layout,
  },
};
</script>

<style scoped lang="scss">
.bold-title {
    font-weight: bold;
    font-size: 20px;
    margin: 10px 0px;
    display: flex;
    &:first-child {
        margin-top: 0px !important;
    }
}
.underlined {
    text-decoration: underline;
    font-weight: 500;
}
</style>
